import { render, staticRenderFns } from "./HomeMedico.vue?vue&type=template&id=53ba027a&scoped=true"
import script from "./HomeMedico.vue?vue&type=script&lang=js"
export * from "./HomeMedico.vue?vue&type=script&lang=js"
import style0 from "./HomeMedico.vue?vue&type=style&index=0&id=53ba027a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba027a",
  null
  
)

export default component.exports